const STORAGE_KEY = 'postLoginRedirect';

export const consumePostLoginRedirect = (): boolean => {
  const target = localStorage.getItem(STORAGE_KEY);
  if (!target) return false;
  localStorage.removeItem(STORAGE_KEY);
  try {
    const url = new URL(target, window.location.origin);
    if (url.origin === window.location.origin) {
      window.location.href = url.toString();
      return true;
    }
  } catch {
  }
  return false;
};
